import { ensureMathIsReady as mathIsReady, ensureMathRendered as mathRendered } from '@instructure/quiz-rce';

// This is needed because of ES Modul Export of RCE is not supported by Sinon
export var ensureMathIsReady = mathIsReady;
export var ensureMathRendered = mathRendered;